module.exports = __webpack_public_path__ + "img/89_23.651ae353.png";